/**
 * Veilans wishlist — localStorage-backed, theme-only.
 * Stores product handles; dispatches `veilans:wishlist-change` on updates.
 */
(function () {
  const STORAGE_KEY = 'veilans_wishlist';

  function read() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    const unique = [...new Set(handles.map(String))];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    document.dispatchEvent(
      new CustomEvent('veilans:wishlist-change', { detail: { handles: unique } })
    );
    updateUI(unique);
    return unique;
  }

  function updateUI(handles) {
    const list = handles || read();
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length ? String(list.length) : '';
      el.setAttribute('data-count', String(list.length));
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const handle = btn.getAttribute('data-product-handle');
      const active = handle && list.includes(handle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = active ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (label) btn.setAttribute('aria-label', label);
    });
  }

  window.VeilansWishlist = {
    get() {
      return read();
    },
    has(handle) {
      return read().includes(String(handle));
    },
    add(handle) {
      if (!handle) return read();
      const list = read();
      if (!list.includes(String(handle))) list.push(String(handle));
      return write(list);
    },
    remove(handle) {
      return write(read().filter((h) => h !== String(handle)));
    },
    toggle(handle) {
      if (!handle) return read();
      return this.has(handle) ? this.remove(handle) : this.add(handle);
    },
  };

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    const handle = btn.getAttribute('data-product-handle');
    window.VeilansWishlist.toggle(handle);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateUI());
  } else {
    updateUI();
  }
})();
